// EcommerceSection.jsx
import React, { useState, useEffect } from "react";
import {
  useNavigate
} from "react-router-dom";
import {
  loadRazorpayScript
} from "../utils/loadRazorpay";
const EcommerceSection = () => {
  const navigate = useNavigate();
  const [loading,
    setLoading] = useState(false);
  const [selectedProduct,
    setSelectedProduct] = useState(null);
  const [showCustomizeForm,
    setShowCustomizeForm] = useState(false);
const [featuredProducts, setFeaturedProducts] = useState([]);
  const [customizeData,
    setCustomizeData] = useState( {
      name: "",
      email: "",
      whatsapp: "",
      message: "",
      colors: "",
      size: "",
      text: "",
      Quantity: "",
      state: "",
      district: "",
      pin: "",
      flat: "",
      apartment: "",
      area: "",
      productName: "",
      instructions: "",
      image: null,
    });

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleBuyClick = (product, e) => {
    e.stopPropagation(); // Prevent navigating when clicking Buy
    setSelectedProduct(product);
    setShowCustomizeForm(true);
    setCustomizeData({
      name: "",
      email: "",
      whatsapp: "",
      message: "",
      Quantity: "",
      colors: "",
      size: "",
      text: "",
      state: "",
      district: "",
      pin: "",
      flat: "",
      apartment: "",
      area: "",
      productName: "",
      instructions: "",
      image: null,
    });
  };

  const handleInputChange = (e) => {
    const {
      name,
      value
    } = e.target;
    setCustomizeData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    setCustomizeData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handleSubmitOrder = async (e) => {
    e.preventDefault();
    let uploadedImageUrl = null;

    if (customizeData.image) {
      const formData = new FormData();
      formData.append("image", customizeData.image);
      setLoading(true);
      try {
        const imageUploadRes = await fetch("https://rangdesaaj.onrender.com/api/upload-image", {
          method: "POST",
          body: formData,
        });
        const imageUploadData = await imageUploadRes.json();
        if (!imageUploadData.url) throw new Error("No URL returned");
        uploadedImageUrl = imageUploadData.url;
      } catch (err) {
        console.error(err);
        setLoading(false);
        alert("⚠️ Image upload failed. Try again.");
        return;
      }
    }

    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load.");
      return;
    }

    let orderData;
    try {
      const orderRes = await fetch("https://rangdesaaj.onrender.com/api/create-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: selectedProduct.price * customizeData.Quantity * 100,
          productName: selectedProduct.name,
          email: customizeData.email,
          currency: "INR",
        }),
      });
      orderData = await orderRes.json();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to create Razorpay order");
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: selectedProduct.price * customizeData.Quantity * 100,
      currency: orderData.currency,
      name: "RangDesaaj",
      description: selectedProduct.name,
      image: "/logo.png",
      order_id: orderData.id,
      handler: async function (response) {
        try {
          const verifyRes = await fetch("https://rangdesaaj.onrender.com/api/verify-payment", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...customizeData,
              imageUrl: uploadedImageUrl,
              razorpayOrderId: orderData.id,
              razorpay_payment_id: response.razorpay_payment_id,
              amount: selectedProduct.price,
              currency: orderData.currency,
              productName: selectedProduct.name,
            }),
          });
          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("🎉 Payment & Order Successful!");
            setLoading(false);
            setShowCustomizeForm(false);
            setSelectedProduct(null);
          } else {
            alert("⚠️ Payment succeeded, but order storing failed.");
            setLoading(false);
          }
        } catch (err) {
          console.error(err);
          alert("❌ Payment received but order verification failed.");
          setLoading(false);
        }
      },
      prefill: {
        name: customizeData.name,
        email: customizeData.email,
        contact: customizeData.whatsapp,
      },
      notes: {
        message: customizeData.message,
        colors: customizeData.colors,
        size: customizeData.size,
        text: customizeData.text,
        Quantity: customizeData.Quantity,
      },
      theme: {
        color: "#000000",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const closeCustomizeForm = () => {
    setShowCustomizeForm(false);
    setSelectedProduct(null);
  };

 {/* const featuredProducts = [{
    id: 1,
    name: "Ocean Wave Coaster Set",
    price: 45,
    mainPrice: 500,
    image: "https://i.postimg.cc/SKDL49dC/IMG-20250606-WA0022.jpg",
    description: "Beautiful ocean-inspired coasters perfect for any home.",
    needsImage: true,
    needsColor: true,
    needsCustomText: true,
    needsRequest: true,
  },
    {
      id: 2,
      name: "Galaxy Serving Tray",
      price: 85,
      mainPrice: 500,
      image: "https://i.postimg.cc/pd2Q3CfP/IMG-20250606-WA0023.jpg",
      description: "Stunning galaxy-themed serving tray for entertaining.",
    },
    {
      id: 3,
      name: "Floral Wall Art",
      price: 120,
      mainPrice: 500,
      image: "https://i.postimg.cc/Jz3cTvBT/IMG-20250606-WA0024.jpg",
      description: "Elegant floral resin art piece for wall decoration.",
    },
    {
      id: 4,
      name: "Ocean Wave Coaster Set",
      price: 45,
      mainPrice: 500,
      image: "https://i.postimg.cc/2SN77r3b/IMG-20250606-WA0025.jpg",
      description: "Beautiful ocean-inspired coasters perfect for any home.",
    },
    {
      id: 5,
      name: "Galaxy Serving Tray",
      price: 85,
      mainPrice: 500,
      image: "/placeholder.svg?height=300&width=300",
      description: "Stunning galaxy-themed serving tray for entertaining.",
    },
    {
      id: 6,
      name: "Floral Wall Art",
      price: 120,
      mainPrice: 500,
      image: "/placeholder.svg?height=300&width=300",
      description: "Elegant floral resin art piece for wall decoration.",
      needsImage: true,
    },
  ];*/}
  
    
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://rangdesaaj.onrender.com/api/featured-products");
        if (!res.ok) throw new Error("Failed to fetch products");
        const data = await res.json();
        setFeaturedProducts(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchProducts();
  }, []);

  return (
    <section className="py-16 bg-white">
      
      {showCustomizeForm && selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">Customize Your Order</h2>
              <button onClick={closeCustomizeForm} className="text-gray-400 hover:text-gray-600 transition-colors">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="px-6 py-4 bg-gray-50 border-b">
              <div className="flex items-center space-x-4">
                <img
                src={selectedProduct.image || "/placeholder.svg"}
                alt={selectedProduct.name}
                className="w-16 h-16 rounded-lg object-cover"
                />
              <div>
                <h3 className="font-bold text-gray-900">{selectedProduct.name}</h3>
                <div className="flex items-center space-x-4 mb-4">
                  <p className="text-xl font-bold text-black">
                    ₹{selectedProduct.price}
                  </p>
                  <p className="text-xl text-gray-500 font-bold text-black line-through">
                    ₹{selectedProduct.mainPrice}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmitOrder} className="p-6 space-y-6">
            <div className="bg-blue-50 rounded-lg p-4 text-center">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{"Let's Customize Together! 🎨"}</h3>
              <p className="text-gray-600 text-sm">
                {"Tell us how you'd like to customize this piece - colors, text, size, or any special requests!"}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Name *
                </label>
                <input
                type="text"
                id="name"
                name="name"
                required
                value={customizeData.name}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email *
              </label>
              <input
              type="email"
              id="email"
              name="email"
              required
              value={customizeData.email}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
              />
          </div>
        </div>
        <div>
          <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-700 mb-2">
            WhatsApp (Optional)
          </label>
          <input
          type="tel"
          id="whatsapp"
          name="whatsapp"
          value={customizeData.whatsapp}
          onChange={handleInputChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
          />
      </div>
      {selectedProduct.needsColor && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="colors" className="block text-sm font-medium text-gray-700 mb-2">
              Preferred Colors
            </label>
            <input
            type="text"
            id="colors"
            name="colors"
            value={customizeData.colors}
            onChange={handleInputChange}
            placeholder="e.g., Blue, Gold, White"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
            />
        </div>
      </div>
    )}
    {selectedProduct.needsCustomText && (
      <div>
        <label htmlFor="text" className="block text-sm font-medium text-gray-700 mb-2">
          Custom Text (if applicable)
        </label>
        <input
        type="text"
        id="text"
        name="text"
        value={customizeData.text}
        onChange={handleInputChange}
        placeholder="Any text you'd like added to the piece"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
        />
    </div>
  )}
  {selectedProduct.needsRequest && (
    <div>
      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
        Special Requests & Additional Details *
      </label>
      <textarea
        id="message"
        name="message"
        required
        rows={4}
        value={customizeData.message}
        onChange={handleInputChange}
        placeholder="Tell us about any special requests, design ideas, or inspiration you have for this piece..."
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
        />
    </div>
  )}
  <div>
    <label htmlFor="Quantity" className="block text-sm font-medium text-gray-700 mb-2">
      Quantity *
    </label>
    <input
    type="tel"
    id="Quantity"
    name="Quantity"
    required
    value={customizeData.Quantity}
    onChange={handleInputChange}
    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
    />
</div>
{selectedProduct.needsImage && (
  <div>
    <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-2">
      Reference Image (Optional)
    </label>
    <input
    type="file"
    id="image"
    name="image"
    accept="image/*"
    onChange={handleImageChange}
    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
    />
  <p className="text-sm text-gray-500 mt-1">
    Upload any reference images or inspiration photos
  </p>
</div>
)}
<hr />
<h4 className="font-semibold text-gray-900 mb-2">Delivery Address</h4>
<div>
<label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
Name *
</label>
<input
type="text"
id="name"
name="name"
required
value={customizeData.name}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-2">
State *
</label>
<input
type="text"
id="state"
name="state"
required
value={customizeData.state}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="district" className="block text-sm font-medium text-gray-700 mb-2">
District *
</label>
<input
type="text"
id="district"
name="district"
required
value={customizeData.district}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="pin" className="block text-sm font-medium text-gray-700 mb-2">
Pin Code *
</label>
<input
type="tel"
id="pin"
name="pin"
required
value={customizeData.pin}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="flat" className="block text-sm font-medium text-gray-700 mb-2">
House/Flat No *
</label>
<input
type="tel"
id="flat"
name="flat"
required
value={customizeData.flat}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="apartment" className="block text-sm font-medium text-gray-700 mb-2">
Apartment Name
</label>
<input
type="text"
id="apartment"
name="apartment"
value={customizeData.apartment}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="area" className="block text-sm font-medium text-gray-700 mb-2">
Area *
</label>
<input
type="text"
id="area"
name="area"
required
value={customizeData.area}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div>
<label htmlFor="instructions" className="block text-sm font-medium text-gray-700 mb-2">
Instructions to First Delivery *
</label>
<textarea
id="instructions"
name="instructions"
required
rows={4}
value={customizeData.instructions}
onChange={handleInputChange}
className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
/>
</div>
<div className="bg-gray-50 rounded-lg p-4">
<h4 className="font-semibold text-gray-900 mb-2">Pricing Information</h4>
<div className="text-sm text-gray-600 space-y-1">
<p>
• Selling Price: ₹{selectedProduct.price}
</p>
<p>
• MRP: ₹{selectedProduct.mainPrice}
</p>
</div>
</div>
<div className="flex flex-col sm:flex-row gap-4 pt-4">
<button
type="button"
onClick={closeCustomizeForm}
className="flex-1 border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-medium hover:bg-gray-50 transition-colors"
>
Cancel
</button>
<button
type="submit"
disabled={loading}
className={`flex-1 py-3 px-6 rounded-lg font-medium transition-colors ${
loading ? "bg-gray-400 cursor-not-allowed": "bg-black hover:bg-gray-800 text-white"
}`}
>
{loading ? (
<span className="flex items-center justify-center">
<svg
className="animate-spin h-5 w-5 mr-2 text-white"
xmlns="http://www.w3.org/2000/svg"
fill="none"
viewBox="0 0 24 24"
>
<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
</svg>
Processing...
</span>
): (
"Place Custom Order"
)}
</button>
</div>
</form>
</div>
</div>
)}
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<div className="text-center space-y-6 mb-16">
<h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Featured Products</h2>
<p className="text-lg text-gray-600 max-w-3xl mx-auto">
Display of featured resin products with high-quality images, descriptions, and prices.
</p>
</div>
<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
{featuredProducts.map((product) => (
<div
key={product.id}
className="group cursor-pointer bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
onClick={() => handleProductClick(product.id)}
>
<div className="bg-gray-200 rounded-t-lg aspect-square overflow-hidden">
<img
src={product.image || "/placeholder.svg"}
alt={product.name}
className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
/>
</div>
<div className="p-6">
<h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
<p className="text-gray-600 mb-4">
{product.description}
</p>
<div className="flex items-center justify-between">
<div className="flex items-center space-x-4 mb-4">
<p className="text-xl font-bold text-black">
₹{product.price}
</p>
<p className="text-xl text-gray-500 font-bold text-black line-through">
₹{product.mainPrice}
</p>
</div>
{/*<button
onClick={(e) => handleBuyClick(product, e)}
className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
>
Buy
</button>*/}
</div>
</div>
</div>
))}
</div>
</div>
</section>
);
};

export default EcommerceSection;